// extracted by mini-css-extract-plugin
module.exports = {"filmbox":"films-page_filmbox__2uxOl","prewbox":"films-page_prewbox__jKcW5"};